import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { takeUntil } from 'rxjs';
import { BaseComponent } from './../../../core/components/base/base.component';
import { FeedbackService } from './../../../core/services/feedback.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { FileDownloadService } from './../../../core/services/file-download.service';

@Component({
  selector: 'app-verify-report',
  templateUrl: './verify-report.component.html',
  styleUrls: ['./verify-report.component.scss']
})
export class VerifyReportComponent extends BaseComponent implements OnInit {
  exportId!: string;
  isLoading = true;
  errorMessage: string | null = null;
  reportData: any = null;

  rawPdfUrl = '';
  pdfUrl!: SafeResourceUrl;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private fileDownloadService: FileDownloadService,
    fs: FeedbackService,
    md: MatDialog
  ) {
    super(fs, md);
  }

  ngOnInit() {
    this.exportId = this.route.snapshot.paramMap.get('exportId')!;
    if (!this.exportId) {
      this.finishWithError('No report ID was provided. Please scan the QR code on the report to verify.');
      return;
    }

    this.verifyReport();
  }

  private verifyReport() {
    this.http.get(`${environment.API_URL}/api/verify-report/${this.exportId}`)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        async (response: any) => {
          this.isLoading = false;
          if (!response.success) {
            this.finishWithError(response.message);
            return;
          }

          this.reportData = response.data;
          this.showToastMessage('Loading report...');

          // If we have a document URL, use it directly
          if (this.reportData.documentUrl) {
            // Use the Azure URL directly for PDF rendering
            this.rawPdfUrl = this.reportData.documentUrl;
            this.pdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.rawPdfUrl);
          } else {
            this.finishWithError('Report document is not available.');
          }
        },
        err => {
          this.isLoading = false;
          this.finishWithError(err.error?.message || 'An error occurred during verification.');
        }
      );
  }

  private finishWithError(message: string) {
    this.errorMessage = message;
    this.showToastMessage(message);
    this.isLoading = false;
  }

  async downloadReport() {
    if (this.rawPdfUrl) {
      const fileName = this.reportData.fileName || `report-${this.exportId}.pdf`;
      await this.fileDownloadService.downloadFromUrl(this.rawPdfUrl, fileName);
    }
  }
}
